import { Select, Option } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { ProviderName, AmplitudeEvents, AmplitudeProperties, AmplitudeServicesSortCriteria } from '@packlink/metrics';
import { getSelectStyles } from './ServiceSortStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { buildSortOptionKey } from '../utils/Icon.js';
import { useSendMetrics } from './MetricsProvider/useSendMetrics.js';
import { ServiceSortingOptions } from '../types/types.js';

const ServiceSort = _ref => {
  let {
    setSortOption,
    sortOption,
    tagsFeatureEnabled
  } = _ref;
  const {
    t
  } = useTranslation();
  const sendMetrics = useSendMetrics();
  const sortingSelectOptions = Object.values(ServiceSortingOptions).filter(sortValue => sortValue === ServiceSortingOptions.TAGGED_SERVICES ? tagsFeatureEnabled : true).map(sortingOption => ({
    label: buildSortOptionKey(sortingOption, t),
    value: sortingOption
  }));
  const getSortAmplitudePayload = selectedSortingCriteria => {
    return {
      [AmplitudeProperties.SERVICES_SORT_CRITERIA]: selectedSortingCriteria === ServiceSortingOptions.BASE_PRICE ? AmplitudeServicesSortCriteria.BASE_PRICE : selectedSortingCriteria === ServiceSortingOptions.TRANSIT_TIME ? AmplitudeServicesSortCriteria.TRANSIT_TIME : AmplitudeServicesSortCriteria.TAGGED_SERVICES
    };
  };
  const handleOnSortServicesChange = (_name, selected) => {
    if (selected) {
      setSortOption(selected);
      sendMetrics({
        providerName: ProviderName.AMPLITUDE,
        eventName: AmplitudeEvents.SERVICE_LIST_APPLY_SORT,
        payload: getSortAmplitudePayload(selected === null || selected === void 0 ? void 0 : selected.value)
      });
    }
  };
  return jsx(Select, {
    css: getSelectStyles,
    label: t('service-list.sort-select.label'),
    name: "sort-selector",
    value: sortOption,
    onChange: handleOnSortServicesChange,
    children: sortingSelectOptions.map(item => jsx(Option, {
      value: item,
      selected: item.value === sortOption.value,
      children: item.label
    }, item.value))
  });
};
var ServiceSort$1 = ServiceSort;

export { ServiceSort$1 as default };
//# sourceMappingURL=ServiceSort.js.map
